import React, {useState} from 'react';
import styled from "styled-components";
import {Button, Icon, Modal} from "react-materialize";
import Filter from "../Transactions/Filters/Filter.react";

const StyledFilters = styled.div`
  .filter-button {
     // light mode styles
     //color: #333D48;
     //background-color: white;
     //border: none;
     //:hover {
     // background-color: #E3EAEF;
     //}
     color: white;
     background-color: transparent;
     border: 1px solid white;
  }
  
  .left-side {
    display: flex;
  }
`

const FiltersModal = ({children, darkMode}) => {
  const [open, setOpen] = useState(false);
  const [appliedFilters, setFilters] = useState(null);
  const [showRangePicker, setShowRangePicker] = useState(false);

  const toggleModal = () => {
    setOpen(!open);
  }

  const handleFilter = (filter) => {
    if (filter === 'Custom Range') {
      setShowRangePicker(true);
    }
    // let newFilters = [...appliedFilters, filter];
    // setFilters(newFilters)
  }

  return (
    <StyledFilters darkMode={darkMode}>
      <Modal
        className={'tb-filters-modal'}
        open={open}
        fixedFooter={false}
        bottomSheet={false}
        actions={[
          <Button>Apply Filters</Button>
        ]}
      >
        <h2>Filters</h2>
        <div><h4>Date</h4></div>
        <div><h4>Flags</h4></div>
        <div><h4>State</h4></div>
        <div><h4>Transaction Count</h4></div>
        {children}
      </Modal>
      <div className={'left-side'}>
        <Button onClick={toggleModal} className={'filter-button'} node={'button'} wave={'light'}>
          Filters
          <Icon left>filter_list</Icon>
        </Button>
        {/*TODO: Add in clear filter buttons*/}
      </div>
    </StyledFilters>
  )
}

export default FiltersModal;